<template>
	<div id="contact">
		<div class="contact_img">
			<img src="../assets/contact.png" alt="联系我们">
		</div>
		<div class="contact_list">
			<ul>
				<li>公司名称<span>昆明联航机动车驾驶培训有限公司</span></li>
				<li>联系电话<span>13759120015</span></li>
				<li>联系地址<span>昆明市五华区普吉街道办事处范家营工业园区13号</span></li>
			</ul>
		</div>
		<div class="bq">Copyright © 2020 学员一点通 All rights reserved</div>
	</div>
</template>

<script>
export default {
	name: 'Contact',
	data () {
		return {
		}
	}
}
</script>
<style scoped>
.contact_img img{
	width: 100%;
	display: block;
}
.contact_list{
	background-color: #fff;
	margin-top: 10px;
	padding: 20px 10px;
}
.contact_list li{
	border-bottom: 1px solid #eee;
	line-height: 44px;
	font-size: 3.5vw;
	color: #333;
	overflow: hidden;
}
.contact_list li:last-child{
	border-bottom: 0;
}
.contact_list li span{
	display: inline-block;
	color: #1accf9;
	text-align: right;
	float: right;
}
.bq{
	padding: 40px 10px;
	text-align: center;
	color: #ccc;
	margin-top: 10px;
}
</style>




// WEBPACK FOOTER //
// src/components/Contact.vue